import React, { PropsWithChildren, useEffect, useMemo, useRef, useState } from 'react';
import { Icon, IconName } from 'react-frontier';
import classNames from 'classnames';

export interface DropdownItemProps{
	value?: any,
	key?: any,
	text: any,
	iconName?: IconName,
	style?: React.CSSProperties,
	className?: string,
	meta?: any,
	active?: boolean,
	onClick?: (value: any)=>void,
}

const DropdownItem = (props: DropdownItemProps)=>{
	var onClick = ()=>{
		if(!props.onClick) return;
		props.onClick(props.value);
	}
	return <div className={classNames("item", { active: props.active }, props.className)} style={props.style} onClick={onClick}>
		{props.iconName && <Icon name={props.iconName} />}
		<div className="text">{props.text}</div>
		{!!props.meta && (
			<div className="meta">{props.meta}</div>
		)}
	</div>
}

interface DropdownProps{
	label?: string,
	placeholder?: string,
	value?: any,
	position?: 'auto' | 'top' | 'bottom',
	style?: React.CSSProperties,
	menuStyle?: React.CSSProperties,
	itemStyle?: React.CSSProperties,
	className?: string,
	options: DropdownItemProps[],
	onChange?: (v: any, i: DropdownItemProps)=>void,
	_toolbar?: boolean,
}

const Dropdown = (props: DropdownProps)=>{
	var dropdownRef = useRef(null);
	var menuRef = useRef<HTMLDivElement>(null);
	var [active, setActive] = useState<boolean>(false);
	var [position, setPosition] = useState<'top' | 'bottom'>('bottom');

	useEffect(()=>{
		if(!active || props.position=='top' || props.position=='bottom'){
			setPosition((props.position as any) || 'bottom');
			return;
		}

		var menu_height = menuRef.current.clientHeight;
		var dropdown_pos = dropdownRef.current.getBoundingClientRect();
		var dropdown_bottom = dropdown_pos.y+dropdown_pos.height+menu_height+15;

		setPosition(dropdown_bottom>=window.innerHeight ? 'top' : 'bottom');
	}, [active, props.position]);

	useEffect(()=>{
		var evl = (ev: MouseEvent) : any=>{
			setTimeout(()=>{
				setActive(false);
			}, 5);
		};

		if(active){
			document.addEventListener('mouseup', evl as any);
		}
		return ()=>{
			document.removeEventListener('mouseup', evl as any);
		}
	}, [active]);

	var getActiveValue = ()=>{
		if(!props.value || !props.options) return null;
		return props.options.find(a=>a.value===props.value);
		// var children_items : ({ props: DropdownItemProps })[] = (Array.isArray(props.children) ? props.children : [props.children]).flat();
		// for(var i of children_items){
		// 	if(!i || !i.props || !i.props.value) continue;
		// 	if(i.props.value===value) return i.props;
		// }
	}

	// useEffect(()=>{
	// 	if(props.onChange){
	// 		var active_value = getActiveValue();
	// 		props.onChange(value || null, active_value);
	// 	}
	// }, [value]);

	var showActive = ()=>{
		setActive(true);
	}

	// var childs = useMemo(()=>{
	// 	return (Array.isArray(props.children) ? props.children : [props.children]).flat().map((a: { props: DropdownItemProps & { key: string } },i)=>{
	// 		if(React.isValidElement(a)){
	// 			return React.cloneElement(a, { 
	// 				key: a.key || `DRP-IT-${a.props.value || i}`,
	// 				...a.props,
	// 				active: props._toolbar ? undefined : (value ? !!(value===a.props.value) : undefined),
	// 				onClick: (v: any)=>{
	// 					setActive(false);
	// 					setValue(typeof a.props.value==='undefined' ? a.props.text : a.props.value);
	// 					if(a.props.onClick) a.props.onClick(v);
	// 				}
	// 			} as unknown)
	// 		}
	// 	});
	// }, [value, props.children, active]);

	var itemClicked = (item: DropdownItemProps)=>{
		if(props.onChange) props.onChange(item.value, item);
		if(item.onClick) item.onClick(item.value);
	}

	var active_value = useMemo(()=>{
		return getActiveValue();
	}, [props.value, props.options]);

	return <div className={classNames("fr dropdown", { active }, props.className)} style={props.style} ref={dropdownRef}> 
		{!!props.label && (
			<div className="fr fieldlabel">{props.label}</div>
		)}
		<div className={classNames("contents", { active })} onClick={showActive}>
			{!!active_value?.iconName && <Icon name={active_value.iconName} className='value-icon' />}
			<div className={classNames("text", { placeholder: !props.value })}>{active_value?.text || props.value || props.placeholder || props.label}</div>
			{!!active_value?.meta && (
				<div className="meta">
					{active_value.meta}
				</div>
			)}
			<Icon name='caret-down' className='dropdown-icon' />
		</div>
		<div className={classNames("menu", {
			active,
			top: position==='top',
			bottom: position==='bottom',
		})} ref={menuRef} style={props.menuStyle}>
			{props.options && props.options.map(a=>(
				<DropdownItem key={a.key || a.value} {...a} />
			))}
		</div>
	</div>
}

export default Dropdown;